export default (settings: any) => settings['joinEntitySearch'] * (1 / 60) * 20
